module.exports = __webpack_public_path__ + "img/pin5.099eedd8.svg";